<template>
  <div v-if="!item.hidden">
    <template v-if="hasMoreThanOneChild(item)">
      <el-submenu :index="resolvePath(item.meta.activePath || item.path)">
        <template slot="title">
          <i
            class="menu-icon"
            :class="item.meta.icon"
            v-if="item.meta.icon"
          ></i>
          <span>{{ $vi18n(`$i18n# ${item.meta.title} #i18n$`) }}</span>
        </template>
        <SidebarItem
          v-for="child in item.children"
          :key="child.path"
          :item="child"
          :base-path="resolvePath(item.path)"
        ></SidebarItem>
      </el-submenu>
    </template>

    <el-menu-item
      v-else
      :index="resolvePath(item.meta.activePath || item.path)"
      @click="handleMenuItemClick(item.path)"
    >
      <i class="menu-icon" :class="item.meta.icon" v-if="item.meta.icon"></i>
      <span slot="title">{{$vi18n(`$i18n# ${item.meta.title} #i18n$`)}}</span>
    </el-menu-item>
  </div>
</template>

<script>
import path from 'path';

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  methods: {
    // $vi18n('$i18n# 没有 #i18n$') hidden $vi18n('$i18n# 属性 #i18n$') $vi18n('$i18n# 的 #i18n$') $vi18n('$i18n# 子路由 #i18n$') $vi18n('$i18n# 大于 #i18n$') 1$vi18n('$i18n# 个 #i18n$')
    hasMoreThanOneChild({ children = [] }) {
      return (
        children.length > 1 && children.filter(item => !item.hidden).length >= 1
      );
    },
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath);
    },
    handleMenuItemClick(routePath) {
      if (routePath.startsWith('http')) {
        window.location.href = routePath;
        return;
      }
      const path = this.resolvePath(routePath);
      if (path === this.$route.path) {
        return;
      }
      this.$router.push({ path });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;

  background-repeat: no-repeat;
  vertical-align: middle;
}
.icon-home {
  background-image: url(~@/assets/images/icon_home.svg);
}
.icon-income {
  background-image: url(~@/assets/images/icon_income.svg);
}
.icon-charts {
  background-image: url(~@/assets/images/icon_charts.svg);
}
.icon-account {
  background-image: url(~@/assets/images/icon_account.svg);
}
.icon-studio {
  background-image: url(~@/assets/images/ico_studio.svg);
}
.icon-activity {
  background-image: url(~@/assets/images/icon_activity.png);
}
.icon-cloudServ {
  background-image: url(~@/assets/images/ico_cloudServ.svg);
}
.icon-act {
  background-image: url(~@/assets/images/icon_act.svg);
  background-size: 20px;
}
.icon-creation {
  background-image: url(~@/assets/images/ico_creat.png);
}
.icon-jpal {
  background-image: url(~@/assets/images/jpal.png);
  background-size: 20px;
}
.icon-wiki {
  background-image: url(~@/assets/images/wiki.png);
  background-size: 20px;
}
.el-submenu .el-menu-item {
  padding-left: 51px !important;
}
.el-menu-item.is-active {
  background-color: #fff5e9;
  .icon-home {
    background-image: url(~@/assets/images/icon_home_active.svg);
  }
  .icon-income {
    background-image: url(~@/assets/images/icon_income_active.svg);
  }
  .icon-charts {
    background-image: url(~@/assets/images/icon_charts_active.svg);
  }
  .icon-act {
    background-image: url(~@/assets/images/icon_act_active.svg);
    background-size: 20px;
  }
  .icon-activity {
    background-image: url(~@/assets/images/icon_activity.png);
  }
  .icon-account {
    background-image: url(~@/assets/images/icon_account_active.svg);
  }
  .icon-studio {
    background-image: url(~@/assets/images/ico_studio_active.svg);
  }
  .icon-cloudServ {
    background-image: url(~@/assets/images/ico_cloudServ_active.svg);
  }
}
/deep/.el-submenu__title, /deep/.el-menu-item {
 span {
  display: inline-block;
  width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
 }
}
</style>
